import { css } from '@emotion/react';
import { ScanTemplateValues, ScanValues } from '@kaiizen/kai-scan-template-system';
import React, { Fragment } from 'react';

import { getScanValuesTooltipRows } from '@/Client/Presenters';
import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { withOpacity } from '@kaiizen/kai-shiki/core';

const VALUES_TABLE = css`
  label: VALUES_TABLE;
  border-collapse: collapse;

  & td {
    padding: 2px 0;
    vertical-align: top;
  }

  & td + td {
    padding-left: 16px;
  }

  /* an equation keeps clear of the left edge, so the longest doesn't span the table edge to edge */
  & td[colspan] {
    padding-top: 0;
    padding-left: 50px;
  }
`;

const VALUE_NAME_CELL = css`
  label: VALUE_NAME_CELL;
  color: ${COLORS.white};
  white-space: nowrap;
`;

const VALUE_CELL = css`
  label: VALUE_CELL;
  text-align: right;
  color: ${COLORS.white};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

/** The equation a value is computed from, on its own row under the value, across both columns: smaller and faded. */
const VALUE_EQUATION_CELL = css`
  label: VALUE_EQUATION_CELL;
  text-align: right;
  color: ${withOpacity(COLORS.paper, 0.58)};
  font-size: ${pxToRem(10.5)};
`;

/** A scan part's values as a tooltip's table: each value's label, then its value, with the equation it's computed from beneath. */
export const FocusedScanValuesTooltipTable = ({ values, valueTemplates }: { values: ScanValues | undefined; valueTemplates: ScanTemplateValues }) => (
  <table css={VALUES_TABLE}>
    <tbody>
      {getScanValuesTooltipRows(values, valueTemplates).map(({ key, label, presentedValue, equation }) => (
        <Fragment key={key}>
          <tr>
            <td css={VALUE_NAME_CELL}>{label}</td>
            <td css={VALUE_CELL}>{presentedValue || '—'}</td>
          </tr>
          {equation && (
            <tr>
              <td css={VALUE_EQUATION_CELL} colSpan={2}>{equation}</td>
            </tr>
          )}
        </Fragment>
      ))}
    </tbody>
  </table>
);
